"use client";

import { ConvexProvider } from "convex/react";
import type { ReactNode } from "react";
import { getConvexReactClient } from "@/lib/convex-react-client";

const convex = getConvexReactClient();

export function PublicConvexProvider({ children }: { children: ReactNode }) {
  return <ConvexProvider client={convex}>{children}</ConvexProvider>;
}
